import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Colors from "../../../ui/global/Colors";
import Fonts from "../../../ui/global/Fonts";
import MessageAlert from "../../../ui/components/MessageAlert";

const Root = styled.div`
    position: absolute;
    top: 5px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0;
    margin: 0;
    z-index: 1000;
`;

export type MessageType = 'image generation error' | null;

interface ArtToastProps {
    messageType: MessageType;
}

const ArtToast = ({ messageType }: ArtToastProps) => {
    const [isMessageVisible, setIsMessageVisible] = useState(false);

    const messageContent = {
        'image generation error': {
            title: 'Error Generating Image',
            body: 'Oops! The AI seems to be taking a coffee break... Please try again later.',
            color: 'red'
        }
    }

    useEffect(() => {
        if (messageType) {
            setIsMessageVisible(true);
        }
    }, [messageType]);

    if (!isMessageVisible) {
        return null;
    }

    return (
        <Root>
            <MessageAlert
                titleText={messageContent[messageType].title}
                bodyText={messageContent[messageType].body}
                color={messageContent[messageType].color}
                onClose={() => setIsMessageVisible(false)}
                includeClose={true}
            />
        </Root>
    );
};

export default ArtToast;
